/* Stylesheet */

/* Media Queries */
@media screen and (min-width: 1200px) {
  .modal_wrapper {
    --height: auto;
    --width: 50%;
    --border-radius: 12px;
  }
}

@media screen and (min-width: 992px) {
  .custom_cohorts {
    --height: 100%;
    --width: 100%;
    --border-radius: 5px;
  }
}

@media screen and (min-width: 1200px) {
  .custom_cohorts {
    --height: 90%;
    --width: 90%;
  }
}
